<template>
    <div
        v-if="times.length > 0"
        class="options"
    >
        <p class="title">{{ title }}</p>
        <div class="times-grid">
            <div
                v-for="time in times"
                :key="time"
                :class="{ 'option': true, 'selected-time': time === chosenTime }"
                @click="handleTimeSelection(time)"
            >
                {{ time }}
            </div>
        </div>
        
    </div>
</template>

<script>
export default {
    emits: ['time-selected'],
    props: {
        times: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        chosenTime: {
            type: String,
            required: false
        },
    },
    methods: {
        handleTimeSelection(time) {
            this.$emit('time-selected', time);
        }
    }
}
</script>

<style lang="scss" scoped>
    .options {
        .active {
            background-color: #0093d6;
            color: #fff;
        }

        @media (max-width: 550px) {
            align-items: start;
            flex-direction: column;
        }
    }

    .title {
        margin-top: 2.5rem;
        opacity: 1;
        color: rgba(25, 42, 68, 1);
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        text-align: left;
        line-height: 24px;
    }

    .times-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px;
    }

    .option {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 44px;
        border-radius: 4px;
        border: 1px solid #00A3E0;
        color: #00A3E0;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;

        cursor: pointer;
        text-align: center;

        &:hover {
            background-color: #00A3E0;
            color: #fff;
        }

        @media (max-width: 550px) {
            padding: 0.5em;
        }
    }

    .selected-time {
        background-color: #00A3E0;
        color: #fff;
    }
</style>